var _path, _mask, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicroLap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4167 15.2817C23.4583 13.4742 18.2355 12.873 18.2355 16.4881C18.2355 20.1031 25.4167 18.2956 25.4167 21.9087C25.4167 25.5219 19.5417 25.5238 17.5833 23.1131M21.5 24.7914V27.3333M21.5 13.8463V11.6666M1.91667 11.6666L20.9752 2.1374C21.1382 2.05603 21.3178 2.01367 21.5 2.01367C21.6822 2.01367 21.8618 2.05603 22.0248 2.1374L41.0833 11.6666",
    stroke: "#CE1111",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_19673_18101",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 17.5417V33.2084C37.1667 34.2472 36.754 35.2434 36.0195 35.9779C35.285 36.7124 34.2888 37.1251 33.25 37.1251H9.75001C8.71124 37.1251 7.71503 36.7124 6.98051 35.9779C6.24599 35.2434 5.83334 34.2472 5.83334 33.2084V17.5417"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-fill",
    d: "M39.6667 17.5417C39.6667 16.161 38.5474 15.0417 37.1667 15.0417C35.786 15.0417 34.6667 16.161 34.6667 17.5417H39.6667ZM5.83334 33.2084H3.33334H5.83334ZM8.33334 17.5417C8.33334 16.161 7.21406 15.0417 5.83334 15.0417C4.45263 15.0417 3.33334 16.161 3.33334 17.5417H8.33334ZM34.6667 17.5417V33.2084H39.6667V17.5417H34.6667ZM34.6667 33.2084C34.6667 33.5841 34.5174 33.9445 34.2517 34.2101L37.7873 37.7457C38.9906 36.5423 39.6667 34.9102 39.6667 33.2084H34.6667ZM34.2517 34.2101C33.9861 34.4758 33.6257 34.6251 33.25 34.6251V39.6251C34.9518 39.6251 36.5839 38.949 37.7873 37.7457L34.2517 34.2101ZM33.25 34.6251H9.75001V39.6251H33.25V34.6251ZM9.75001 34.6251C9.37429 34.6251 9.01395 34.4758 8.74828 34.2101L5.21274 37.7457C6.4161 38.949 8.0482 39.6251 9.75001 39.6251V34.6251ZM8.74828 34.2101C8.4826 33.9445 8.33334 33.5841 8.33334 33.2084H3.33334C3.33334 34.9102 4.00938 36.5423 5.21274 37.7457L8.74828 34.2101ZM8.33334 33.2084V17.5417H3.33334V33.2084H8.33334Z",
    fill: "#CE1111",
    mask: "url(#path-2-inside-1_19673_18101)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroLap);
export default __webpack_public_path__ + "static/media/micro-lap.575ac0c055d46862e226c2a2e33c5ece.svg";
export { ForwardRef as ReactComponent };